module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame_4108@2x(3).png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame_4108%402x(3).png
// module id = lGRY
// module chunks = 93